import { useFileInfo } from "@/api/services/global/file";
import { black } from "@/theme/colors";
import { state } from "@/theme/colors";
import { FCC } from "@/types/common";
import { downloadFileFromPath } from "@/utils/export";
import { showError } from "@/utils/error";
import { Divider, Link, Stack, Typography, styled } from "@mui/material";
import { useState } from "react";

type TMatchFileLinkProps = {
  label: string;
  filePath: string;
  isShowDivider?: boolean;
};

export const MatchFileLink: FCC<TMatchFileLinkProps> = ({ label, filePath, isShowDivider = false }) => {
  const { data: infoResult } = useFileInfo(filePath);
  const fileName = infoResult?.data?.name || filePath.split("/").pop() || "";
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (downloading) return;
    try {
      setDownloading(true);
      await downloadFileFromPath(filePath);
    } catch (error) {
      showError(error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Stack width="100%">
        <Typography variant="cap12" color={black[70]}>
          {label}
        </Typography>
        <Link
          component="button"
          variant="body14"
          underline="always"
          onClick={handleDownload}
          sx={{
            color: state.link_1,
            cursor: downloading ? "wait" : "pointer",
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          {fileName}
        </Link>
      </Stack>
      {isShowDivider && <DividerWrapper />}
    </>
  );
};

const DividerWrapper = styled(Divider)`
  margin: 8px 0;
  width: 100%;
`;
